import {DependencyList, useEffect, useState} from 'react';

type clearFunction = () => void;

const useTimeout = (callback: () => void, delay = 0, deps: DependencyList = []): clearFunction => {
    const [timeOutId, setTimeOutId] = useState<NodeJS.Timeout>();
    useEffect(() => {
        setTimeOutId(setTimeout(callback, delay));
        return () => clearTimeout(timeOutId);
    }, deps);
    return () => clearTimeout(timeOutId);
};

export default useTimeout;
